
import { defineComponent } from 'vue'
import useModeDescriptor from './UseModesDescriptor.json'
import { VCodeMirror } from 'vue3-code-mirror'
import { decode } from 'js-base64'
import Column from 'primevue/column'
import DataTable from 'primevue/datatable'
export default defineComponent({
    name: 'lovs-detail',
    components: { VCodeMirror, Column, DataTable },
    props: {
        lov: {
            type: Object,
            required: false
        }
    },
    emits: ['close', 'apply'],
    data() {
        return {
            selectedLov: {} as any,
            useModeDescriptor,
            code: '',
            rows: [],
            codeMirror: {} as any,
            codeMirrorVisiable: false,
            label: null,
            name: null,
            options: {
                mode: 'text/x-mysql',
                indentWithTabs: true,
                smartIndent: true,
                lineWrapping: true,
                matchBrackets: true,
                autofocus: true,
                theme: 'eclipse',
                lineNumbers: true,
                readOnly: true
            }
        }
    },
    mounted() {
        this.selectedLov = { ...this.lov }
        this.decode()
        this.setupCodeMirror()
    },
    watch: {
        lov() {
            this.selectedLov = { ...this.lov }
            this.decode()
            this.setupCodeMirror()
        }
    },
    methods: {
        setupCodeMirror() {
            if (this.$refs.codeMirror) {
                this.codeMirror = (this.$refs.codeMirror as any).editor as any
            }
        },
        escapeXml(value: string) {
            return value
                .replace(/'/g, "'")
                .replace(/"/g, '"')
                .replace(/>/g, '>')
                .replace(/</g, '<')
                .replace(/&/g, '&')
                .replace(/&apos;/g, "'")
        },
        decode() {
            if (this.selectedLov.itypeCd === 'QUERY') {
                this.codeMirrorVisiable = true
                this.options.mode = 'text/x-mysql'
                let x = JSON.parse(this.lov?.lovProviderJSON)
                this.code = this.escapeXml(decode(x.QUERY.STMT))
            } else if (this.selectedLov.itypeCd === 'SCRIPT') {
                this.codeMirrorVisiable = true
                this.options.mode = 'text/javascript'
                let x = JSON.parse(this.lov?.lovProviderJSON)
                this.code = this.escapeXml(decode(x.SCRIPTLOV.SCRIPT))
            } else if (this.selectedLov.itypeCd === 'FIX_LOV') {
                this.codeMirrorVisiable = false
                let x = JSON.parse(this.lov?.lovProviderJSON)
                Array.isArray(x.FIXLISTLOV.ROWS.ROW) ? (this.rows = x.FIXLISTLOV.ROWS.ROW) : (this.rows = Object.values(x.FIXLISTLOV.ROWS))
            } else if (this.selectedLov.itypeCd === 'DATASET') {
                this.codeMirrorVisiable = false
                let x = JSON.parse(this.lov?.lovProviderJSON)
                this.label = x.DATASET.LABEL
            } else if (this.selectedLov.itypeCd === 'JAVACLASS') {
                this.codeMirrorVisiable = false
                let x = JSON.parse(this.lov?.lovProviderJSON)
                this.label = x.JAVACLASS.label
                this.name = x.JAVACLASS.name
            }
        }
    }
})
